import { apiGet, apiPut, apiPost, apiDelete } from "@redriver/cinnamon";

const NAMESPACE = "SETTINGS/SERVICES";

export const ActionTypes = {
  GetServices: `${NAMESPACE}/GET_SERVICES`,
  AddService: `${NAMESPACE}/ADD_SERVICE`,
  UpdateService: `${NAMESPACE}/UPDATE_SERVICE`,
  RemoveServiceById: `${NAMESPACE}/REMOVE_SERVICE_BY_ID`
};

export const getServices = ({ filters, pagination }, { dealerOfficeId }) => {
  const { pageSize, pageNumber } = pagination;
  const { search, sortName, sortDirection } = filters;

  return apiGet(ActionTypes.GetServices, `services`, {
    dealerOfficeId,
    pageSize,
    pageNumber,
    search,
    includeMandatory: true,
    sortName,
    sortDirection,
  });
};

export const addService = ({ templateUpload, ...data }, { dealerOfficeId, uploadDoc }) => {
  const templateUploadObject = !uploadDoc
      ? null
      : {
        name: templateUpload.name,
        content: uploadDoc.split(",")[1],
        size: templateUpload.size,
        contentType: templateUpload.type,
      };
  return apiPost(ActionTypes.AddService, `services`, { ...data, dealerOfficeId, templateUpload: templateUploadObject })};

export const removeService = id =>
  apiDelete(ActionTypes.RemoveServiceById, `services/${id}`);

export const editService = ({ templateUpload, ...data}, { id, uploadDoc },) =>
{
    const templateUploadObject = !uploadDoc
        ? null
        : {
            name: templateUpload.name,
            content: uploadDoc.split(",")[1],
            size: templateUpload.size,
            contentType: templateUpload.type,
        };
    return apiPut(ActionTypes.UpdateService, `services/${id}`, {
        ...data,
        templateUpload: templateUploadObject,
    });
}
